export function decodeEmail(input: string): string {
  return atob(input);
}
